//services
import JwtService from "../services/JwtService";

//libraries
// import { i18n } from "../../main";
import moment from "moment-timezone";
import { toastStore } from "@/store/toastManagement";
import { i18n } from "@/translation";
import { forEach } from "lodash";
import { MODULES } from "./constants";
import ApiService from "../services/ApiService";
// import router from "@/router";

// 🚨 GET REQUEST HELPER FUNCTION
export const GET_REQUEST_HANDLER = async (store, url, state, params = {}) => {
  try {
    const response = await ApiService.get(url, { params });
    const data = response?.data?.data ?? response?.data ?? response;
    store[state] = data;
    return data;
  } catch ({ error }) {
    throw error;
  }
};

// 🚨 Color generation
export const generateColors = (count = 0) => {
  if (!count) return [];
  const baseColors = [
    "#3B00ED",
    "#62C085",
    "#676767",
    "#F7BFA5",
    "#FF6B6B",
    "#4ECDC4",
    "#45B7D1",
    "#FFA07A",
  ];

  if (count <= baseColors.length) {
    return baseColors.slice(0, count);
  }

  const colors = [...baseColors];
  while (colors.length < count) {
    colors.push(generateRandomColor());
  }
  return colors;
};
export const generateRandomColor = () => {
  const hue = Math.floor(Math.random() * 360);
  const saturation = 60 + Math.floor(Math.random() * 20);
  const lightness = 50 + Math.floor(Math.random() * 20);
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};

//

export const isBranch = (route) => {
  const { entityType } = getEntityQuery(route) ?? {};
  return lowerCase(entityType) === "branch";
};

export const isCompany = (route) => {
  const { entityType } = getEntityQuery(route) ?? {};
  return lowerCase(entityType) === "company";
};

// 🚨 GET MODULE DASHBOARD
export const getModuleDashboard = () => {
  const currentView = localStorage.getItem("currentView");

  if (!currentView) {
    localStorage.setItem("currentView", "station");
  }

  return MODULES.find((mod) => mod.view === localStorage.getItem("currentView"))
    ?.link;
};

export const getCurrentModule = () => {
  const currentView = localStorage.getItem("currentView");

  if (!currentView) {
    localStorage.setItem("currentView", "station");
  }

  return MODULES.find(
    (mod) => mod.view === localStorage.getItem("currentView")
  );
};

export const productOrderArrangement = (items) => {
  const arrangement = ["PMS", "AGO", "DPK", "LPG"];

  // 🚨An object
  if (!Array.isArray(items)) {
    const ordered = {};
    arrangement.forEach((key) => {
      if (key in items) {
        ordered[key] = items[key];
      }
    });

    // Add remaining keys not in arrangement
    Object.keys(items).forEach((key) => {
      if (!arrangement.includes(key)) {
        ordered[key] = items[key];
      }
    });

    return ordered;
  }

  // Format 2: If it's an array of objects
  const getProductKey = (item) => item.product || item.productItem;

  const ordered = arrangement
    .map((key) => items.find((item) => getProductKey(item) === key))
    .filter(Boolean);

  const unmatched = items.filter(
    (item) => !arrangement.includes(getProductKey(item))
  );

  return [...ordered, ...unmatched];
};

//pdf api response conversion
export const convertFile = (response, name) => {
  // CHECK FILE FORMAT
  let fileName = "report"; // default fallback
  let type;

  const contentType = response.headers["content-type"];
  if (contentType.includes("csv")) type = "csv";
  else if (contentType.includes("pdf")) type = "pdf";
  else if (contentType.includes("vnd.ms-excel")) type = "xls";
  else if (
    contentType.includes(
      "vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    )
  )
    type = "xlsx";

  fileName = `${name}.${type}`;

  // Use the response data directly without wrapping in a new Blob
  const blob = response.data || response;
  const url = URL.createObjectURL(blob);
  const tempLink = document.createElement("a");
  tempLink.href = url;
  tempLink.setAttribute("download", fileName);
  document.body.appendChild(tempLink);
  tempLink.click();

  document.body.removeChild(tempLink);
  window.URL.revokeObjectURL(url);
};

export const paramsConversion = (params) => {
  if (!params) {
    return {};
  }

  const {
    query,
    exportType = null,
    isExport,
    type = null,
    dateRange,
  } = params ?? {};

  const { page = 1, search, rowsPerPage } = query ?? {};
  const { startDate, endDate } = dateRange ?? {};

  return {
    page,
    query: search,
    export: exportType,
    type,
    pageLimit: rowsPerPage,
    startDate,
    endDate,
  };
};

//auth
export const userInSession = () => {
  const accessToken = JwtService.getToken();
  return !!accessToken;
};

export const getAcutalEntity = (name, routeQuery) => {
  const entity = getLocalStorageService("entityDetails");
  const { companyId, branchId, regionId, groupId } = routeQuery ?? {};

  const queryPriority = [
    { entityId: branchId, entityType: "branch" },
    { entityId: regionId, entityType: "region" },
    { entityId: groupId, entityType: "group" },
    { entityId: companyId, entityType: "company" },
  ];
  const routeEntity = queryPriority.find(
    (query) => query.entityType === lowerCase(name) && query.entityId
  );
  if (routeEntity) {
    return routeEntity;
  } else if (lowerCase(entity.entityType) === lowerCase(name)) {
    return { entityId: entity.id, entityType: lowerCase(entity.entityType) };
  } else {
    return { entityId: entity[`${name}Id`], entityType: lowerCase(name) };
  }
};

export const getEntityQuery = (routeQuery) => {
  const entity = getLocalStorageService("entityDetails");
  const { companyId, branchId, regionId, groupId } = routeQuery ?? {};

  const queryPriority = [
    { entityId: branchId, entityType: "branch" },
    { entityId: regionId, entityType: "region" },
    { entityId: groupId, entityType: "group" },
    { entityId: companyId, entityType: "company" },
  ];

  // Find the primary entity from the query parameters
  const selectedEntity = queryPriority.find((param) => param.entityId);

  // Get the remaining entities in the query to check for previous entity values
  const remainingEntities = queryPriority.filter(
    (param) => param.entityId && param.entityType !== selectedEntity?.entityType
  );
  let prevEntityType,
    prevEntityId = null;

  if (remainingEntities.length > 0) {
    prevEntityType = remainingEntities[0].entityType;
    prevEntityId = remainingEntities[0].entityId;
  } else if (
    selectedEntity &&
    entity &&
    selectedEntity?.entityType?.toLowerCase() !== "company"
  ) {
    prevEntityType = entity.entityType;
    prevEntityId = entity.id;
  }

  const finalEntity = {
    entityId: selectedEntity?.entityId ?? entity?.id,
    entityType:
      selectedEntity?.entityType?.toLowerCase() ??
      entity?.entityType?.toLowerCase(),
    prevEntityId: prevEntityId,
    prevEntityType: prevEntityType,
  };

  return finalEntity;
};

export const subEntity = () => {
  const entity = getLocalStorageService("sub-entity");
  if (entity !== null || entity != undefined) {
    return entity;
  } else {
    return {
      entityTo: "",
      entityFrom: "",
      entityId: "",
    };
  }
};

export const determineEntity = (routeQuery, companyId) => {
  let entityId;
  let entityType;

  if (routeQuery.branchId) {
    entityId = routeQuery.branchId;
    entityType = "branch";
  } else if (routeQuery.groupId) {
    entityId = routeQuery.groupId;
    entityType = "group";
  } else if (routeQuery.regionId) {
    entityId = routeQuery.regionId;
    entityType = "region";
  } else if (routeQuery.otherId) {
    entityId = routeQuery.otherId;
    entityType = "other";
  } else {
    entityId = companyId;
    entityType = "company";
  }

  return { entityId, entityType };
};

export const getImage = (icon) => {
  return new URL(`../../assets/svg/${icon}`, import.meta.url).href;
};

//toast
export const errorToast = (details, code) => {
  if (!details) return;
  toastStore().error({
    title: `${i18n.global.t("updatePrice.error")} ${code ? `(${code})` : ""} `,
    subtitle: details,
    position: "Top",
    icon: "forbidden.svg",
  });
};

export const successToast = (details) => {
  toastStore().success({
    title: i18n.global.t("staffManagement.success"),
    subtitle: details,
    position: "Top",
    icon: "bulk-verify.svg",
  });
};

//role check
export const getUserRoles = () => {
  const roles = lowerCase(getLocalStorageService("auth-user")?.role);
  return roles?.split(",");
};

export const doesUserRoleHave = (role) => {
  const userRoles = getUserRoles();
  const foundRole = userRoles.filter((userRole) => {
    return lowerCase(userRole) === lowerCase(role);
  });

  return foundRole?.length > 0 ? true : false;
};

export const checkRole = (roleList) => {
  if (!roleList) return;
  //convert the role list to lowercase
  const roles = Array.isArray(roleList)
    ? roleList.map((role) => lowerCase(role))
    : roleList;
  const userRoles = getUserRoles();
  const queryParams = Object.fromEntries(
    new URLSearchParams(window.location.search)
  );

  const { entityType } = getEntityQuery(queryParams);
  //show all navigation to super admin
  if (userRoles?.includes("supportadmin")) {
    return true;
  }
  //show all branch navigation to company role
  // if (entityType === "branch" && userRoles?.includes("company")) {
  //   return true;
  // }

  //show navigations based on roles
  if (Array.isArray(roles)) {
    return roles.some((role) => {
      return (
        lowerCase(role) === "supportadmin" ||
        userRoles?.includes(lowerCase(role))
      );
    });
  }

  return (
    lowerCase(roles) === "supportadmin" ||
    getUserRoles()?.includes(lowerCase(roles))
  );
};
///

//localstorage services
export const getLocalStorageService = (key) => {
  if (!key) return alert("enter key");

  return JSON.parse(localStorage.getItem(key));
};
export const setLocalStorageService = (key, value) => {
  if (!key) return alert("enter set key");
  const stringifiedValue = JSON.stringify(value);
  localStorage.setItem(key, stringifiedValue);
};
export const clearLocalStorageService = (key) => {
  if (!key) return alert("enter set key");

  localStorage.removeItem(key);
};

// formatters
export function shortenNumber(num) {
  if (!num && num !== 0) return "N/A";

  const absNum = Math.abs(num);
  const sign = num < 0 ? "-" : "";

  const formatNumber = (value) => {
    if (value % 1 === 0) {
      return value.toString();
    }
    // Truncate to 1 decimal place without rounding
    const truncated = Math.floor(value * 10) / 10;
    return truncated.toString();
  };

  if (absNum >= 1000000000) {
    return sign + formatNumber(absNum / 1000000000) + "B";
  } else if (absNum >= 1000000) {
    return sign + formatNumber(absNum / 1000000) + "M";
  } else if (absNum >= 1000) {
    return sign + formatNumber(absNum / 1000) + "K";
  } else {
    return formatNumber(num);
  }
}
// export function shortenNumber(num) {
//   if (!num && num !== 0) return "N/A";

//   const absNum = Math.abs(num);
//   const sign = num < 0 ? "-" : "";

//   if (absNum >= 1000000000) {
//     return sign + (absNum / 1000000000).toFixed(1) + "B";
//   } else if (absNum >= 1000000) {
//     return sign + (absNum / 1000000).toFixed(1) + "M";
//   } else if (absNum >= 1000) {
//     return sign + (absNum / 1000).toFixed(1) + "K";
//   } else {
//     return num.toFixed(1);
//   }
// }
export function trimText(text, maxLength) {
  if (text?.length > maxLength) {
    return text?.substring(0, maxLength) + "...";
  } else {
    return text;
  }
}
const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

// Checks if date string includes timezone offset like +01:00 or -0500
// const hasOffset = (dateStr) => /([+-]\d{2}:\d{2}|Z)$/.test(dateStr);
const hasOffset = (dateStr) => {
  const str = String(dateStr);
  const match = str.match(/([+-])(\d{2}):(\d{2})$/);
  if (!match) return false;

  const [, , hours, minutes] = match;
  return !(hours === "00" && minutes === "00");
};

export const utcDate = (date) => {
  if (date === "N/A") return "N/A";
  if (!date) return;
  const parsedDate = hasOffset(date) ? moment(date) : moment.utc(date);
  return parsedDate.format(); // Default ISO format
};

export const formatDate = (date, format = "YYYY-MM-DD") => {
  if (date === "N/A") return "N/A";
  if (!date) return;
  // console.log(hasOffset(date), "has offset");
  const parsedDate = hasOffset(date) ? moment(date) : moment.utc(date);
  return parsedDate.format(format);
};

export const DateFromNow = (date) => {
  if (date === "N/A") return "N/A";
  if (!date) return;
  const parsedDate = hasOffset(date) ? moment(date) : moment.utc(date);
  return parsedDate.fromNow();
};
// export const utcDate = (date) => {
//   if (!date) return;
//   return moment.utc(date).tz(userTimeZone).format();
// };

// export const formatDate = (date, format = "YYYY-MM-DD") => {
//   if (!date) return;
//   return moment.utc(date).tz(userTimeZone).format(format);
// };

// export const DateFromNow = (date) => {
//   if (!date) return;
//   return moment.utc(date).tz(userTimeZone).fromNow();
// };

export const getLastMonth = () => {
  const currentDate = new Date();
  const previousMonthDate = new Date(
    currentDate.setMonth(currentDate.getMonth() - 1)
  );

  const year = previousMonthDate.getFullYear();
  const month = String(previousMonthDate.getMonth() + 1).padStart(2, "0");
  const day = String(previousMonthDate.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const getLastWeek = () => {
  const currentDate = new Date();
  const previousWeekDate = new Date(
    currentDate.setDate(currentDate.getDate() - 7)
  );

  const year = previousWeekDate.getFullYear();
  const month = String(previousWeekDate.getMonth() + 1).padStart(2, "0");
  const day = String(previousWeekDate.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const formatNumber = (value, unit = null) => {
  if (value === null || value === undefined || isNaN(value)) return "N/A";
  let num = Number(value);
  let finalUnit = "";

  switch (unit) {
    case "weight":
      finalUnit = "kg";
      break;
    case "volume":
      finalUnit = "L";
      break;
    case "volumeFull":
      finalUnit = "Ltrs";
      break;
    case "tempCelcius":
      finalUnit = "°C";
      break;
    default:
      finalUnit = "";
  }

  return `${Number(num).toLocaleString("en", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
  })} ${finalUnit}`.trim();
};

export const lowerCase = (str) => {
  if (!str || typeof str !== "string") {
    // console.log("invalid argument lowerCase function");
    return "N/A";
  }
  return str.trim().toLowerCase();
};
//

//translation
export const translateText = (path) => {
  return path ? i18n.global.t(path) : "no text";
};

export const currencyFormat = (number, format) => {
  // Handle invalid number inputs
  if (number === null || number === undefined || typeof number !== "number") {
    return number ?? "N/A";
  }

  // Default currency format if not provided
  let currencyFormat = "NGN"; // Default to NGN
  try {
    const entityDetails = JSON.parse(localStorage.getItem("entityDetails"));
    currencyFormat = entityDetails?.currency ?? "NGN";
  } catch (error) {
    // console.warn("Failed to parse entityDetails from localStorage:", error);
  }

  // Use passed format or fallback to default
  const appliedFormat = format || currencyFormat;

  // Convert the number to a formatted string
  const formattedAmount = Number(number).toLocaleString("en", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });

  // Map decimal part to superscripts
  const superscriptMapping = {
    0: "⁰",
    1: "¹",
    2: "²",
    3: "³",
    4: "⁴",
    5: "⁵",
    6: "⁶",
    7: "⁷",
    8: "⁸",
    9: "⁹",
  };

  const [integerPart, decimalPart = "00"] = formattedAmount.split(".");
  const decimalSuperscript = decimalPart
    .split("")
    .map((digit) => superscriptMapping[digit] || digit) // Handle unexpected values gracefully
    .join("");

  // Return the formatted string with currency and superscript decimals
  return `${appliedFormat} ${integerPart}.${decimalSuperscript}`;
};

export const getCurrencySymbol = () => {
  try {
    const entityDetails = JSON.parse(localStorage.getItem("entityDetails"));
    return entityDetails?.currencyCode || "₦"; // Default to ₦ if not found
  } catch (error) {
    return "₦"; // Default symbol in case of error
  }
};

export const getCurrencyCode = () => {
  try {
    const entityDetails = JSON.parse(localStorage.getItem("entityDetails"));
    return entityDetails?.currency || "NGN"; // Default to NGN if not found
  } catch (error) {
    return "NGN"; // Default code in case of error
  }
};

//get route query
export const getRouteQuery = (key) => {
  return queryParam?.[key];
};
export const tableExport = (exportName, type, result) => {
  if (!result || !exportName || !type) {
    errorToast("Missing required parameters for download.");
    return;
  }

  // Define MIME types for supported formats
  const mimeTypes = {
    pdf: "application/pdf",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    csv: "text/csv",
  };

  const mimeType = mimeTypes[type];

  if (!mimeType) {
    errorToast("Unsupported file type.");
    return;
  }

  // Create Blob with the correct MIME type
  const blob = new Blob([result], { type: mimeType });

  // Generate the download URL
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");

  // Set download attributes
  link.href = url;
  link.setAttribute("download", `${exportName}.${type}`);
  document.body.appendChild(link);

  // Trigger the download
  link.click();

  // Cleanup
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
export const formateExportName = (title) => {
  return `${title + "_" + formatDate(new Date(), "MMMM_Do YYYY")}`;
};

// STRIPE INJECTION
export function loadStripeScript() {
  return new Promise((resolve, reject) => {
    if (document.querySelector('script[src="https://js.stripe.com/v3/"]')) {
      resolve(); // Script already loaded
      return;
    }

    const script = document.createElement("script");
    script.src = "https://js.stripe.com/v3/";
    script.async = true;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

export function removeStripeScript() {
  const stripeScript = document.querySelector(
    'script[src="https://js.stripe.com/v3/"]'
  );
  if (stripeScript) {
    stripeScript.remove();
    // console.log("Stripe.js script removed successfully");
  }
}
